module.exports = __webpack_public_path__ + "img/victorinox.2e658199.svg";